import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import CreateLabCorporate from "./addLabCorporate";
import { Pagination } from "react-bootstrap";
import "./hm-theme.css";

function LabCorporateDetails() {
  const [labCorporateDetails, setLabCorporateDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const searchUrl = `/api/lab-corporate/searchByNameOrEmailOrOrgcode`;
      const response = await axios.post(searchUrl, { searchTerm }, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabCorporateDetails(response.data.content || []);
      setCurrentPage(response.data.number || 0);
      setTotalPages(response.data.totalPages || 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const trans = await axios.get(`/api/lab-corporate/getAll`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setLabCorporateDetails(trans.data.content || []);
      setCurrentPage(trans.data.number || 0);
      setTotalPages(trans.data.totalPages || 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData(currentPage);
  };

  const handleClick = (orgcode) => {
    navigate(`/users/lab-corporate-profile/${orgcode}`);
  };

  const handleViewLabs = (corporateId) => {
    navigate(`/users/corporate-labs/${corporateId}`);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      <Dashboard />
      {loader && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">science</i>
                Lab Controllers & Corporates
              </h2>
              <p className="hm-page-subtitle">Manage lab corporate accounts and partner networks</p>
            </div>
            <button className="btn-hm-primary" onClick={() => setIsModalOpen(true)}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
              Add Lab Controller
            </button>
          </div>

          {/* Search Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">search</i>
                Search Lab Controllers
              </h3>
            </div>
            <div className="hm-card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control ps-4"
                      placeholder="Search by name, email or orgcode..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <i className="material-icons position-absolute text-muted" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "1.1rem" }}>
                      search
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table Card */}
          <div className="hm-card">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">domain</i>
                Lab Corporate Network
              </h3>
              <span className="hm-badge hm-badge-primary">{labCorporateDetails.length} records</span>
            </div>
            <div className="hm-card-body p-0">
              <div style={{ overflowX: "auto" }}>
                <table className="hm-table">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Corporate Name</th>
                      <th>Org Code</th>
                      <th>Contact</th>
                      <th>Client Code</th>
                      <th>Admin Link</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {labCorporateDetails.length === 0 ? (
                      <tr>
                        <td colSpan="7">
                          <div className="hm-empty-state">
                            <i className="material-icons">science</i>
                            <p>{loader ? "Loading lab controllers..." : "No lab corporate details found"}</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      labCorporateDetails.map((accd) => (
                        <tr key={accd.id}>
                          <td>
                            <button
                              type="button"
                              className="btn btn-link p-0 fw-bold text-start text-decoration-none"
                              style={{ color: "#2f3a88" }}
                              onClick={() => handleClick(accd.orgcode)}
                            >
                              {accd.email}
                            </button>
                          </td>
                          <td className="fw-semibold">{accd.name}</td>
                          <td>
                            <span className="hm-badge hm-badge-primary">{accd.orgcode}</span>
                          </td>
                          <td>{accd.contact || "—"}</td>
                          <td><code>{accd.clientId || "—"}</code></td>
                          <td>{accd.adminEmail || "—"}</td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm rounded-pill px-3"
                              onClick={() => handleViewLabs(accd.id)}
                            >
                              View Labs
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="d-flex justify-content-center py-3">
                  <Pagination className="hm-pagination">
                    <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                    {renderPageNumbers()}
                    <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1} />
                    <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1} />
                  </Pagination>
                </div>
              )}
            </div>
          </div>

        </div>
      </div>

      {isModalOpen && (
        <CreateLabCorporate
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
        />
      )}
    </div>
  );
}

export default LabCorporateDetails;
